import { LoggedUserProviders } from 'app/LoggedUserProviders';
import { DYNAMIC_URLS, URLS } from 'consts';
import { lazy } from 'react';
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom';
// import { CookiesPromptModal } from 'shared/ui/Modals/CookiesPromptModal';
// import { CookiesSettingsModal } from 'shared/ui/Modals/CookiesSettingsModal';

import { ModalsProvider } from '@mantine/modals';
import {
  AuthController,
  ProtectedRouteController,
  // TODO: remove when PERG-558 is closed
  // RequiredUserAgreementsController,
} from './controllers';

const Layout = lazy(() =>
  import('widgets/Layout').then(m => ({ default: m.Layout })),
);
const MetaTitle = lazy(() =>
  import('shared/ui/MetaTitle').then(m => ({ default: m.MetaTitle })),
);
const MassSigneAcceptModalRestorer = lazy(() =>
  import('widgets/mass-signe-accept-model').then(m => ({
    default: m.MassSigneAcceptModalRestorer,
  })),
);
const BetaObserver = lazy(() =>
  import('hooks/beta/beta-observer').then(m => ({ default: m.BetaObserver })),
);
const ReleaseAnnouncementMount = lazy(() =>
  import('widgets/release-announcement').then(m => ({
    default: m.ReleaseAnnouncementMount,
  })),
);

const Account = lazy(() =>
  import('pages/Account').then(m => ({ default: m.Account })),
);
const Api = lazy(() => import('pages/Api').then(m => ({ default: m.Api })));
const Contacts = lazy(() =>
  import('pages/Contacts').then(m => ({ default: m.Contacts })),
);
const DataStreamAdd = lazy(() =>
  import('pages/DataStreamAdd').then(m => ({ default: m.DataStreamAdd })),
);
const DataStreamEdit = lazy(() =>
  import('pages/DataStreamEdit').then(m => ({ default: m.DataStreamEdit })),
);
const DataStreams = lazy(() =>
  import('pages/DataStreams').then(m => ({ default: m.DataStreams })),
);
const DataTypes = lazy(() =>
  import('pages/DataTypes').then(m => ({ default: m.DataTypes })),
);
const DefaultQueueDesigner = lazy(() =>
  import('pages/default-queue-designer').then(m => ({
    default: m.DefaultQueueDesigner,
  })),
);
const Document = lazy(() =>
  import('pages/Document').then(m => ({ default: m.Document })),
);
const Documents = lazy(() =>
  import('pages/Documents').then(m => ({ default: m.Documents })),
);
const Error = lazy(() =>
  import('pages/Error').then(m => ({ default: m.Error })),
);
const FormEdit = lazy(() =>
  import('pages/Forms').then(m => ({ default: m.FormEdit })),
);
const FormsList = lazy(() =>
  import('pages/Forms').then(m => ({ default: m.FormsList })),
);
const Go = lazy(() => import('pages/Go').then(m => ({ default: m.Go })));
const Home = lazy(() => import('pages/Home').then(m => ({ default: m.Home })));
const Invitation = lazy(() =>
  import('pages/Invitation').then(m => ({ default: m.Invitation })),
);
const NotFound = lazy(() =>
  import('pages/NotFound').then(m => ({ default: m.NotFound })),
);
const OauthAzure = lazy(() =>
  import('pages/OauthAzure').then(m => ({ default: m.OauthAzure })),
);
const OauthGoogle = lazy(() =>
  import('pages/OauthGoogle').then(m => ({ default: m.OauthGoogle })),
);
const OauthOkta = lazy(() =>
  import('pages/OauthOkta').then(m => ({ default: m.OauthOkta })),
);
const ZealidCallback = lazy(() =>
  import('pages/ZealidCallback').then(m => ({ default: m.ZealidCallback })),
);
const OrganisationBoards = lazy(() =>
  import('pages/OrganisationBoards').then(m => ({
    default: m.OrganisationBoards,
  })),
);
const OrganisationBranding = lazy(() =>
  import('pages/OrganisationBranding').then(m => ({
    default: m.OrganisationBranding,
  })),
);
const OrganisationDetails = lazy(() =>
  import('pages/OrganisationDetails').then(m => ({
    default: m.OrganisationDetails,
  })),
);
const OrganisationMailCustomization = lazy(() =>
  import('pages/OrganisationMailCustomization').then(m => ({
    default: m.OrganisationMailCustomization,
  })),
);
const ExtForms = lazy(() =>
  import('pages/ExtForms').then(m => ({ default: m.ExtForms })),
);
const ExtDocumentSignatures = lazy(() =>
  import('pages/ExtDocumentSignatures').then(m => ({
    default: m.ExtDocumentSignatures,
  })),
);
const RequestPasswordReset = lazy(() =>
  import('pages/RequestPasswordReset').then(m => ({
    default: m.RequestPasswordReset,
  })),
);
const ResetPassword = lazy(() =>
  import('pages/ResetPassword').then(m => ({ default: m.ResetPassword })),
);
const Signe2 = lazy(() =>
  import('pages/signe-v2').then(m => ({ default: m.Signe2 })),
);
const TemplateAdd = lazy(() =>
  import('pages/TemplateAdd').then(m => ({ default: m.TemplateAdd })),
);
const TemplateAttachmentAdd = lazy(() =>
  import('pages/TemplateAttachmentAdd').then(m => ({
    default: m.TemplateAttachmentAdd,
  })),
);
const TemplateAttachmentAddFromTemplate = lazy(() =>
  import('pages/TemplateAttachmentAddFromTemplate').then(m => ({
    default: m.TemplateAttachmentAddFromTemplate,
  })),
);
const TemplateAttachmentEdit = lazy(() =>
  import('pages/TemplateAttachmentEdit').then(m => ({
    default: m.TemplateAttachmentEdit,
  })),
);
const TemplateBranding = lazy(() =>
  import('pages/TemplateBranding').then(m => ({
    default: m.TemplateBranding,
  })),
);
const TemplateEdit = lazy(() =>
  import('pages/TemplateEdit').then(m => ({ default: m.TemplateEdit })),
);
const Templates = lazy(() =>
  import('pages/Templates').then(m => ({ default: m.Templates })),
);
const TransactionDetails = lazy(() =>
  import('pages/TransactionDetails').then(m => ({
    default: m.TransactionDetails,
  })),
);
const TransactionEntries = lazy(() =>
  import('pages/TransactionEntries').then(m => ({
    default: m.TransactionEntries,
  })),
);
const TransactionEntry = lazy(() =>
  import('pages/TransactionEntry').then(m => ({
    default: m.TransactionEntry,
  })),
);
const Transactions = lazy(() =>
  import('pages/Transactions').then(m => ({ default: m.Transactions })),
);
const Packages = lazy(() =>
  import('pages/packages').then(m => ({ default: m.Packages })),
);
const MiniPortalPage = lazy(() =>
  import('pages/mini-portal').then(m => ({ default: m.MiniPortalPage })),
);

const DsLayout = lazy(() =>
  import('pages/dev-design-system').then(m => ({ default: m.DsLayout })),
);
const DevDesignSystemRedirect = lazy(() =>
  import('pages/dev-design-system').then(m => ({
    default: m.DevDesignSystemRedirect,
  })),
);
const ColorsSection = lazy(() =>
  import('pages/dev-design-system').then(m => ({
    default: m.ColorsSection,
  })),
);
const TypographySection = lazy(() =>
  import('pages/dev-design-system').then(m => ({
    default: m.TypographySection,
  })),
);
const SpacingSection = lazy(() =>
  import('pages/dev-design-system').then(m => ({
    default: m.SpacingSection,
  })),
);
const ElevationSection = lazy(() =>
  import('pages/dev-design-system').then(m => ({
    default: m.ElevationSection,
  })),
);
const ButtonSection = lazy(() =>
  import('pages/dev-design-system').then(m => ({
    default: m.ButtonSection,
  })),
);
const InputSection = lazy(() =>
  import('pages/dev-design-system').then(m => ({ default: m.InputSection })),
);
const AlertSection = lazy(() =>
  import('pages/dev-design-system').then(m => ({ default: m.AlertSection })),
);
const AvatarSection = lazy(() =>
  import('pages/dev-design-system').then(m => ({
    default: m.AvatarSection,
  })),
);
const CardSection = lazy(() =>
  import('pages/dev-design-system').then(m => ({ default: m.CardSection })),
);
const CheckboxSection = lazy(() =>
  import('pages/dev-design-system').then(m => ({
    default: m.CheckboxSection,
  })),
);
const CountBadgeSection = lazy(() =>
  import('pages/dev-design-system').then(m => ({
    default: m.CountBadgeSection,
  })),
);
const StepperSection = lazy(() =>
  import('pages/dev-design-system').then(m => ({
    default: m.StepperSection,
  })),
);

export const BASENAME = '/v2';

const router = createBrowserRouter(
  [
    ...(import.meta.env.DEV
      ? [
          {
            path: URLS.devDesignSystem,
            element: <DsLayout />,
            children: [
              { index: true, element: <DevDesignSystemRedirect /> },
              { path: 'colors', element: <ColorsSection /> },
              { path: 'typography', element: <TypographySection /> },
              { path: 'spacing', element: <SpacingSection /> },
              { path: 'elevation', element: <ElevationSection /> },
              { path: 'components/alert', element: <AlertSection /> },
              { path: 'components/avatar', element: <AvatarSection /> },
              { path: 'components/button', element: <ButtonSection /> },
              { path: 'components/card', element: <CardSection /> },
              { path: 'components/checkbox', element: <CheckboxSection /> },
              {
                path: 'components/count-badge',
                element: <CountBadgeSection />,
              },
              { path: 'components/input', element: <InputSection /> },
              { path: 'components/stepper', element: <StepperSection /> },
            ],
          },
        ]
      : []),
    {
      path: DYNAMIC_URLS.go({ id: ':id' }),
      element: <Go />,
    },
    {
      path: URLS.portal,
      errorElement: <Error />,
      element: (
        <ModalsProvider>
          <AuthController>
            <LoggedUserProviders>
              <MiniPortalPage />
            </LoggedUserProviders>
          </AuthController>
        </ModalsProvider>
      ),
    },
    {
      errorElement: <Error />,
      path: DYNAMIC_URLS.transactionPage({
        type: ':type',
        resourceId: ':resourceId',
      }),
      element: (
        <ModalsProvider>
          <AuthController>
            <LoggedUserProviders>
              <Signe2 />
            </LoggedUserProviders>
          </AuthController>
        </ModalsProvider>
      ),
    },
    {
      element: (
        <ModalsProvider>
          <Outlet />
        </ModalsProvider>
      ),
      errorElement: <Error />,
      children: [
        { path: URLS.oauthAzure, element: <OauthAzure /> },
        { path: URLS.oauthGoogle, element: <OauthGoogle /> },
        { path: URLS.oauthOkta, element: <OauthOkta /> },
        { path: URLS.zealidCallback, element: <ZealidCallback /> },
        {
          element: (
            <>
              <AuthController>
                <LoggedUserProviders>
                  <BetaObserver />
                  <MetaTitle />
                  <MassSigneAcceptModalRestorer />
                  <ReleaseAnnouncementMount />
                  <Layout />
                </LoggedUserProviders>
              </AuthController>
              {/* NOTE: cookies and GTM temporarily hidden in production */}
              {/* <CookiesPromptModal /> */}
              {/* <CookiesSettingsModal /> */}
            </>
          ),
          children: [
            { path: URLS.archiveDocuments, element: <Documents archive /> },
            { path: URLS.archivePackages, element: <Packages archive /> },
            { path: URLS.account, element: <Account /> },
            { path: URLS.api, element: <Api /> },
            { path: URLS.contacts, element: <Contacts /> },
            {
              path: DYNAMIC_URLS.document({ documentId: ':documentId' }),
              element: <Document />,
            },
            {
              path: DYNAMIC_URLS.contracts({ documentId: ':documentId' }),
              element: <Document />,
            },
            { path: URLS.documents, element: <Documents /> },
            { path: URLS.contracts, element: <Documents /> },
            { path: URLS.dataStreams, element: <DataStreams /> },
            { path: URLS.dataStreamAdd, element: <DataStreamAdd /> },
            { path: URLS.templateAdd, element: <TemplateAdd /> },
            { path: URLS.templates, element: <Templates /> },
            {
              path: DYNAMIC_URLS.dataStreamEdit({
                dataStreamId: ':dataStreamId',
              }),
              element: <DataStreamEdit />,
            },
            { path: URLS.dataTypes, element: <DataTypes /> },
            {
              path: DYNAMIC_URLS.invitation({ invitationId: ':invitationId' }),
              element: <Invitation />,
            },
            {
              path: URLS.home,
              element: <Home />,
            },
            {
              path: DYNAMIC_URLS.templateAttachmentAdd({
                templateId: ':templateId',
              }),
              element: <TemplateAttachmentAdd />,
            },
            {
              path: DYNAMIC_URLS.templateAttachmentAddFromTemplate({
                templateId: ':templateId',
                baseTemplateId: ':baseTemplateId',
              }),
              element: <TemplateAttachmentAddFromTemplate />,
            },
            {
              path: DYNAMIC_URLS.templateAttachmentEdit({
                templateId: ':templateId',
                attachmentName: ':attachmentName',
              }),
              element: <TemplateAttachmentEdit />,
            },
            {
              path: DYNAMIC_URLS.templateBranding({
                templateId: ':templateId',
              }),
              element: <TemplateBranding />,
            },
            {
              path: DYNAMIC_URLS.templateEdit({
                templateId: ':templateId',
              }),
              element: <TemplateEdit />,
            },
            {
              path: URLS.forms,
              element: <FormsList />,
            },
            {
              path: DYNAMIC_URLS.formEdit({
                formId: ':formId',
              }),
              element: <FormEdit />,
            },
            {
              path: URLS.defaultQueue,
              element: <DefaultQueueDesigner />,
            },
            {
              path: URLS.packages,
              element: <Packages />,
            },
            {
              path: DYNAMIC_URLS.transactionDetails({
                transactionId: ':transactionId',
                transactionDataStream: ':transactionDataStream',
              }),
              element: <TransactionDetails />,
            },
            {
              path: DYNAMIC_URLS.transactionDetails({
                transactionId: ':transactionId',
                transactionDataStream: ':transactionDataStream',
                tab: ':tab',
              }),
              element: <TransactionDetails />,
            },
            {
              path: DYNAMIC_URLS.transactionEntries({
                transactionId: ':transactionId',
                transactionDataStream: ':transactionDataStream',
              }),
              element: <TransactionEntries />,
            },
            {
              path: DYNAMIC_URLS.transactionEntry({
                transactionId: ':transactionId',
                transactionDataStream: ':transactionDataStream',
                transactionEntry: ':transactionEntry',
              }),
              element: <TransactionEntry />,
            },
            {
              path: DYNAMIC_URLS.transactionEntry({
                transactionId: ':transactionId',
                transactionDataStream: ':transactionDataStream',
                transactionEntry: ':transactionEntry',
                tab: ':tab',
              }),
              element: <TransactionEntry />,
            },
            { path: URLS.transactions, element: <Transactions /> },
            {
              path: DYNAMIC_URLS.organisationDetails({
                organisationId: ':organisationId',
              }),
              element: <OrganisationDetails />,
            },
            {
              path: DYNAMIC_URLS.organisationBoards({
                organisationId: ':organisationId',
              }),
              element: <OrganisationBoards />,
            },
            {
              path: DYNAMIC_URLS.organisationBoard({
                organisationId: ':organisationId',
                boardId: ':boardId',
              }),
              element: <OrganisationBoards />,
            },
            {
              path: DYNAMIC_URLS.organisationBoardSettings({
                organisationId: ':organisationId',
                boardId: ':boardId',
                settingsTabKey: ':settingsTabKey',
              }),
              element: <OrganisationBoards />,
            },
            {
              path: DYNAMIC_URLS.organisationBranding({
                organisationId: ':organisationId',
              }),
              element: <OrganisationBranding />,
            },
            {
              path: DYNAMIC_URLS.organisationMailCustomization({
                organisationId: ':organisationId',
              }),
              element: <OrganisationMailCustomization />,
            },
          ],
        },
        {
          element: <ProtectedRouteController />,
          children: [
            {
              path: URLS.requestPasswordReset,
              element: <RequestPasswordReset />,
            },
            {
              path: URLS.resetPassword,
              element: <ResetPassword />,
            },
          ],
        },
        {
          path: DYNAMIC_URLS.formExternal({
            formSlug: ':formSlug',
          }),
          Component: ExtForms,
        },
        {
          path: DYNAMIC_URLS.documentSignaturesExternal({
            docSlug: ':docSlug',
          }),
          Component: ExtDocumentSignatures,
        },
        {
          path: '*',
          element: <NotFound />,
        },
      ],
    },
  ],
  { basename: BASENAME },
);

export const Router = () => <RouterProvider router={router} />;
